/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import {
  QueryClient,
  QueryFunctionContext,
  QueryKey,
} from "@tanstack/react-query";
import { GramCore } from "../core.js";
import { pluginsListDistributionPlugins } from "../funcs/pluginsListDistributionPlugins.js";
import { combineSignals } from "../lib/primitives.js";
import { RequestOptions } from "../lib/sdks.js";
import { ListDistributionPluginsResult } from "../models/components/listdistributionpluginsresult.js";
import {
  ListDistributionPluginsRequest,
  ListDistributionPluginsSecurity,
} from "../models/operations/listdistributionplugins.js";
import { unwrapAsync } from "../types/fp.js";
export type DistributionPluginsQueryData = ListDistributionPluginsResult;

export function prefetchDistributionPlugins(
  queryClient: QueryClient,
  client$: GramCore,
  request: ListDistributionPluginsRequest,
  security?: ListDistributionPluginsSecurity | undefined,
  options?: RequestOptions,
): Promise<void> {
  return queryClient.prefetchQuery({
    ...buildDistributionPluginsQuery(
      client$,
      request,
      security,
      options,
    ),
  });
}

export function buildDistributionPluginsQuery(
  client$: GramCore,
  request: ListDistributionPluginsRequest,
  security?: ListDistributionPluginsSecurity | undefined,
  options?: RequestOptions,
): {
  queryKey: QueryKey;
  queryFn: (
    context: QueryFunctionContext,
  ) => Promise<DistributionPluginsQueryData>;
} {
  return {
    queryKey: queryKeyDistributionPlugins({
      skillId: request.skillId,
      gramSession: request.gramSession,
      gramProject: request.gramProject,
    }),
    queryFn: async function distributionPluginsQueryFn(
      ctx,
    ): Promise<DistributionPluginsQueryData> {
      const sig = combineSignals(
        ctx.signal,
        options?.signal,
        options?.fetchOptions?.signal,
      );
      const mergedOptions = {
        ...options?.fetchOptions,
        ...options,
        signal: sig,
      };

      return unwrapAsync(pluginsListDistributionPlugins(
        client$,
        request,
        security,
        mergedOptions,
      ));
    },
  };
}

export function queryKeyDistributionPlugins(
  parameters: {
    skillId: string;
    gramSession?: string | undefined;
    gramProject?: string | undefined;
  },
): QueryKey {
  return ["@gram/client", "plugins", "listDistributionPlugins", parameters];
}
